import React from 'react'
export function SelectForm(props){
    return (
        <div className={props.className+" width-100"}>
            <select type={props.type} name={props.name} onChange={props.onChange} placeholder={props.placeholder} className="brd-glb paddAll-10 bdg-inp rad-5 sizeF-1em width-100 height-100 box-border" value={props.value}>
                {props.children}
            </select>
        </div>
    )
}